

export enum EModalPosition {
  TOP = "flex items-center justify-center text-center mx-4 my-10 md:my-20",
  CENTER = "flex items-end sm:items-center justify-center p-4 min-h-full",
}

export enum EModalWidth {
  SM = "sm:max-w-sm",
  MD = "sm:max-w-md",
  LG = "sm:max-w-lg",
  XL = "sm:max-w-xl",
  XXL = "sm:max-w-2xl",
  XXXL = "sm:max-w-3xl",
  XXXXL = "sm:max-w-4xl",
  VXL = "sm:max-w-5xl",
  VIXL = "sm:max-w-6xl",
  VIIXL = "sm:max-w-7xl",
}
